import { post } from '@/common/request';

const brandMap = new Map([
  ['add', '/resource/brand/create']
]);

export default brandMap;
/*
 * 品牌
 * https://yapi.lanhanba.com/project/319/interface/api/64042
 * src/common/hook/useBrand.tsx
*/
export function postResourceBrandListQuery(params?: any, firstQuest?: boolean) {
  return post('/property/brand/page', { ...params }, {
    isMock: false,
    needHint: true,
    needCancel: !firstQuest, // 初次请求时不可取消，避免同时使用多个组件时，晚强求的被取消无法展示初始值
    // mockId: 321,
  });
};


/*
 * 品牌详情
 * https://yapi.lanhanba.com/project/319/interface/api/54557
*/
export function postBrandDetail(params?: any) {
  return post('/property/brand/detail', { ...params }, false);
};

export function addBrand(params?: any) {
  return post('/resource/brand/create', { ...params }, { needHint: true, proxyApi: '/resserv' });
}


